import React from 'react';
import { Link } from 'react-router-dom';
// Data
import { tourDataArray } from '../../utils/data/TourData';
// Constants
import { CONTACT_PAGE_URL } from '../../utils/Routes';
import { FMTY_RATE } from '../../utils/Constants';

function TouringContainer() {
  return (
    <section>
      <article className='text-center px-6 py-12'>
        <h2 className='text-4xl md:text-6xl neon_text_duo_magenta_violet font-titleFont leading-[3rem]'>
          Find me at these locations
        </h2>
      </article>

      <section className='grid px-8 mx-auto py-8 gap-y-6 w-full min-w-xl max-w-3xl'>
        {tourDataArray.map((item, index) => (
          <div key={index} className='grid w-full gap-y-2'>
            {/* Header Row */}
            <div className='flex justify-between w-full text-sm text-white font-semibold tracking-wide'>
              <span>
                {item.city}
                {item.state && `, ${item.state}`}{' '}
                {item.country !== 'USA' && item.country}
              </span>
              <span>{item.dateArriving}</span>
            </div>

            {/* Sexy description */}
            <p className='text-white/80 text-sm leading-relaxed'>
              {item.description}
            </p>

            {/* Divider */}
            {index !== tourDataArray.length - 1 && (
              <div className='neon_line my-4' />
            )}
          </div>
        ))}
      </section>
      <section className='px-8 mx-auto py-8 w-full min-w-xl max-w-3xl text-white'>
        <h3 className='text-3xl text-center mb-4 neon_text_thin_magenta_pink font-titleFont'>
          Fly Me To You
        </h3>
        <p className='mb-4 text-base leading-relaxed'>
          Like What you see? If you wish to have me specifically come see you in
          your city, the rate is <strong>{FMTY_RATE}</strong> for a minimum of 2
          hours. Longer sessions can be arranged at your request.
        </p>
        <p className='mb-4 text-base leading-relaxed'>
          This rate does not include travel expenses, such as airfare, hotel
          accommodations, meals, and rental car.
        </p>
        <p className='mb-4 text-base leading-relaxed'>
          Advance notice is required, and a deposit is due at the time of
          booking to secure your FMTY appointment.
        </p>
        <p className='mb-6 text-base leading-relaxed'>
          To inquire about FMTY, you can complete out my form and contact me
          directly.
        </p>
        <div className='grid gap-4 justify-center'>
          <Link
            to={CONTACT_PAGE_URL}
            className='flex items-center justify-center gap-3 cursor-pointer bg-colour2 hover:bg-colour1/30 neon_button border-2 border-solid border-colour1 px-6 py-2 w-full text-center rounded max-w-xs mx-auto'
          >
            <span>Contact Me</span>
          </Link>
        </div>
      </section>
    </section>
  );
}

export default TouringContainer;
